import { render, staticRenderFns } from "./Error_mobile.vue?vue&type=template&id=56c5123e&scoped=true&"
import script from "./Error_mobile.vue?vue&type=script&lang=js&"
export * from "./Error_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Error_mobile.vue?vue&type=style&index=0&id=56c5123e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5123e",
  null
  
)

export default component.exports